import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import { ICommonRequestInfo } from './types';
import {
  IAiAssistUsageReportItem,
  IAiAssistUsageReportOverviewParams,
} from './types/aiAssistUsageReportTypes';

export const getAiAssistUsageOverviewReport = (
  { clinicId }: ICommonRequestInfo,
  data: IAiAssistUsageReportOverviewParams,
): IResponse<{
  total: number;
  items: IAiAssistUsageReportItem[];
}> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/ai-assist/report`,
    params: data,
  });

export const generateAiAssistUsageReport = (
  { clinicId }: ICommonRequestInfo,
  data: Omit<IAiAssistUsageReportOverviewParams, 'pagination'>,
): IResponse<BlobPart> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/ai-assist/report/export`,
    responseType: 'blob',
    params: data,
  });
